export const CATEGORIES = {
  "6914277d2fb79c91edafbd32": {
    title: "Creative and artistic",
    description: "Unleash your inner artist with hands-on workshops, inspiring classes, and creative experiences that spark joy. From pottery and painting to photography and DIY crafts.",
    bgClass: "hero-bg-listing-creative"
  },
  "691427892fb79c91edafbd34": {
    title: "Performing arts",
    description: "No stage too big, no dream too bold. Step into the spotlight and let your passion shine.",
    bgClass: "hero-bg-listing-arts"
  },
  "691427962fb79c91edafbd36": {
    title: "Sports",
    description: "Get your game on with activities that keep you moving and having fun, whether you're a seasoned player or just starting out, there's a match for everyone here.",
    bgClass: "hero-bg-listing-sports"
  },
  "691427e02fb79c91edafbd46": {
    title: "Games and puzzles",
    description: "Sharpen your mind and bring on the laughs with activities that challenge, entertain, and connect. It's playtime for thinkers, teams, and anyone up for a little friendly competition.",
    bgClass: "hero-bg-listing-games"
  },
  "691427e92fb79c91edafbd48": {
    title: "Outdoor and nature based activities",
    description: "Step outside and soak it all in — fresh air, wide-open spaces, and unforgettable experiences. These activities help you reconnect with the world (and yourself) beyond the screen.",
    bgClass: "hero-bg-listing-outdoor"
  },
  "691427b82fb79c91edafbd3c": {
    title: "Culinary activities",
    description: "Roll up your sleeves and get cooking — or tasting! Come hungry, leave inspired.",
    bgClass: "hero-bg-listing-culinary"
  },
  "6914280a2fb79c91edafbd4c": {
    title: "Intellectual and learning",
    description: "Feed your curiosity and explore something new. From thought-provoking talks and language classes to hands-on workshops and deep dives into fascinating topics — these activities are all about growing your mind in fun, inspiring ways.",
    bgClass: "hero-bg-listing-intel"
  }
};
